<template>
  <div class="content-body">
    <div class="top">效果数据</div>
    <div class="body">
      <div class="condition">
        <div class="form">
          <div class="demo-input-suffix">
            时间:
            <el-date-picker v-model="form.pay_time" type="daterange" value-format="yyyy-MM-dd" style="width: 250px;" align="right" size="small" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
          </div>
          <div class="demo-input-suffix">
            广告主:
            <el-select v-model="form.type" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option :label="company_name" value="1"></el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            广告组:
            <el-select v-model="form.plan_id" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            推广计划:
            <el-select v-model="form.adv_id" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option :label="item.adv_name" :value="item.adv_id" v-for="(item, index) in advLists" :key="index"></el-option>
            </el-select>
          </div>
          <!-- <div class="demo-input-suffix">
            广告状态:
            <el-select v-model="form.status" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option label="待投放" value="1"></el-option>
              <el-option label="投放中" value="2"></el-option>
              <el-option label="日预算消耗完" value="3"></el-option>
              <el-option label="总预算消耗完" value="4"></el-option>
              <el-option label="时间到期" value="5"></el-option>
              <el-option label="余额不足" value="6"></el-option>
            </el-select>
          </div> -->
          <el-button type="primary" @click="search" size="small">查询</el-button>

          <div style="margin: 20px 0;">
            <!-- <div class="demo-input-suffix">
              投放平台:
              <el-select v-model="form.system" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
                <el-option label="不限" value=""></el-option>
                <el-option label="Android" value="1"></el-option>
                <el-option label="IOS" value="2"></el-option>
                <el-option label="PC" value="3"></el-option>
              </el-select>
            </div> -->
            <!-- <el-button type="primary" @click="search" size="small">查询</el-button> -->
          </div>
          <div class="line-lists"></div>
        </div>
      </div>

      <div class="data-body">
        <div class="top-data">
          <div class="data-item blue">
            <div class="font">曝光量（次）</div>
            <div class="num" v-text="num['read_num']"></div>
          </div>
          <div class="data-item org">
            <div class="font">点击量（次）</div>
            <div class="num" v-text="num['look_num']"></div>
          </div>
          <div class="data-item green">
            <div class="font">点击率</div>
            <div class="num" v-text="num['click_l']"></div>
          </div>
          <div class="data-item zs">
            <div class="font">点击均价（元）</div>
            <div class="num" v-text="num['click_p']"></div>
          </div>
          <div class="data-item red">
            <div class="font">消耗金额（元）</div>
            <div class="num" v-text="num['pay_money']"></div>
          </div>
          <!-- <el-select v-model="form.value" placeholder="请选择" size="small" style="margin: 34px 0 0 360px;" @change="getData">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select> -->
        </div>
        <div class="make" style="margin: 20px 0; ">
          <div id="myChart" :style="{width: '1622px', height: '374px'}"></div>
        </div>
        <div class="line-lists"></div>
        <div class="make" style="margin-top: 20px;">
          <el-button type="primary" size="small" @click="exportExcel">下载报表</el-button>
        </div>
        <div class="table">
          <el-table :data="tableData" border style="width: 100%" size="small" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
            <el-table-column prop="today" width="" label="时间" align="center"></el-table-column>
            <el-table-column prop="read_num" sortable label="展现数" width="" align="center"></el-table-column>
            <el-table-column prop="look_num" sortable label="点击数" width="" align="center"></el-table-column>
            <el-table-column prop="click_l" sortable label="点击率" width="" align="center"></el-table-column>
            <el-table-column prop="cpc" sortable label="CPC" width="" align="center"></el-table-column>
            <el-table-column prop="cpm" sortable label="CPM" width="" align="center"></el-table-column>
            <el-table-column prop="pay_money" sortable label="消耗(元)" width="" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
export default {
  /* global require */
  name: 'index',
  data() {
    return {
      form: {
        status: '',
        type: '',
        plan_id: '',
        adv_id: '',
        pay_time: [],
        system: '',
        value: '1'
      },
      tableData: [],
      options: [{
        value: '1',
        label: '展现数'
      }, {
        value: '2',
        label: '点击数'
      }, {
        value: '3',
        label: '点击率'
      }, {
        value: '4',
        label: 'CPC'
      }, {
        value: '5',
        label: 'CPM'
      }, {
        value: '6',
        label: '消耗（元）'
      }],
      num: [],
      planLists: [],
      advLists: [],
      company_name: ''
    };
  },
  mounted() {
    this.company_name = JSON.parse(sessionStorage.getItem('user_info'))['company_name'];
    this.setTimeInit();
    this.$http.post('/trader/plan/getLists').then(res => {
      if (res.code === 200) {
        this.planLists = res.data;
        this.getData();
      }
    });
  },
  methods: {
    exportExcel() {
      const { export_json_to_excel } = require('@/plugin/Export2Excel');
      const tHeader = ['时间', '展现数', '点击数', '点击率', 'CPC', 'CPM', '消耗(元)'];
      const filterVal = ['today', 'read_num', 'look_num', 'click_l', 'cpc', 'cpm', 'pay_money'];
      const list = this.tableData;
      const data = this.formatJson(filterVal, list);
      export_json_to_excel(tHeader, data, '效果数据');
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    setTimeInit() {
      const day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
      const preToday = day1.getFullYear() + '-' + ((day1.getMonth() + 1) < 10 ? '0' + (day1.getMonth() + 1) : (day1.getMonth() + 1)) + '-' + (day1.getDate() < 10 ? '0' + day1.getDate() : day1.getDate());
      const day2 = new Date();
      day2.setTime(day2.getTime());
      const today = day2.getFullYear() + '-' + ((day2.getMonth() + 1) < 10 ? '0' + (day2.getMonth() + 1) : (day2.getMonth() + 1)) + '-' + (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate());
      this.form.pay_time = [today, today];
    },
    getData() {
      this.$http.post('/trader/data/getTableLists', this.form).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.num = res.num;
          const option = {
            xAxis: {
              type: 'category',
              data: res.static.data
            },
            legend: {
              data: ['展示量', '点击量', '费用']
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '8%',
              left: '5%',
              right: '5%',
              bottom: '12%'
            },
            tooltip: {
              show: true, // 显示提示框
              trigger: 'axis'
            },
            series: [{
            name: '展示量',
            type: 'line',
            stack: 'Total',
            smooth: true,
            color: '#5156BE',
            data: res.static.value
          },
          {
            name: '点击量',
            type: 'line',
            stack: 'Total',
            smooth: true,
            color: '#2AB57D',
            data: res.static.look_value
          },
          {
            name: '费用',
            type: 'line',
            stack: 'Total',
            smooth: true,
            data: res.static.money_value
          },]
          };
          const echartsRecords = echarts.init(document.getElementById('myChart'), 'walden');
          echartsRecords.setOption(option);
          this.$function.hiddenLoading();
        }
      });
    },
    search() {
      this.getData();
    }
  },
  watch: {
    'form.plan_id'(newVal, oldVal) {
      if (newVal !== '') {
        this.$http.post('/trader/plan/getAdvListsForPlanId', {
          plan_id: newVal
        }).then(res => {
          if (res.code === 200) {
            this.advLists = res.data;
          }
        });
      } else {
        this.advLists = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    line-height: 54px;
    color: #333;
    padding-left: 22px;
  }
  .line-lists {
    height: 6px;
    background-color: #f5f5f5;
  }
  .body {
    width: calc(100% - 69px);
    margin-left: 23px;
    width: 1640px;
    .condition {
      margin-top: 20px;
      width: 1400px;
      height: 55px;
      .form {
        float: left;
        width: 1645px;
      }
      .other {
        float: right;
        width: 440px;
      }
      .demo-input-suffix {
        display: inline-block;
        font-size: 14px;
        color: #999;
        margin-right: 31px;
      }
    }
    .page-c {
      margin-top: 20px;
      text-align: right;
      margin-right: 30px;
    }
  }

  .data-body {
    clear: both;
    padding-top: 20px;
    .top-data {
      display: flex;
      margin: 10px 0 0 0;
      .data-item {
        min-width: 120px;
        height: 44px;
        padding: 11px 21px;
        color: #fff;
        margin-right: 20px;
        .font {
          font-size: 12px;
          margin-bottom: 5px;
        }
        .num {
          font-size: 22px;
        }
      }
      .blue {
        background: #4cc9f5;
      }
      .org {
        background: #ffc484;
      }
      .green {
        background: #28d7d2;
      }
      .zs {
        background: #c596f5;
      }
      .red {
        background: #ff749f;
      }
    }
    .table {
      margin: 20px 0 100px 0;
    }
  }

</style>
